import { useI18N } from "@sundae/react-hooks";
import { Notice } from "@sundae/ui-toolkit";
import { FC } from "react";

const SubmittingZapTransaction: FC = () => {
  const { t } = useI18N("transactions");

  return (
    <div className="grid w-full gap-8 ">
      <Notice
        className="mx-auto mt-4 w-fit xl:mt-0"
        type="info"
        size="xs"
        title={t("transaction.submittingTitle")}
      >
        {t("transaction.confirmInWallet")}
      </Notice>
    </div>
  );
};

export default SubmittingZapTransaction;
